import React from "react";

function Plot_Canvas() {
  return (
    <div>
      <h1>Plot_Canvas Component</h1>
      <p>This is the Plot Canvas tutorial page content.</p>
    </div>
  );
}

export default Plot_Canvas;
